import styled from "@emotion/styled";
import { Field, Form as FormikForm } from "formik";
import { HexColorPicker } from "react-colorful";
import { FiX } from "react-icons/fi";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  gap: 2rem;
  @media (max-width: 800px) {
    flex-direction: column;
    row-gap: 8px;
    align-items: flex-start;
  }
`;

export const SavedColorsWrapper = styled.div`
  flex: 3;
`;

export const ColorList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  list-style: none;
  padding: 0;
`;

export const ColorItem = styled.li`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0.5rem 1rem;
  background: #f8fafc;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
`;

export const ColorBox = styled.div<{ color: string }>`
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background-color: ${(props) => props.color};
  border: 1px solid #cbd5e1;
`;

export const ModalContent = styled.div`
  max-width: 420px;
  padding: 2rem;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const PickerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
`;

export const ColorPreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 0.5rem;
`;

export const BottomActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
`;

export const ModalTitle = styled.h3`
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 0;
`;

export const StyledForm = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StyledHexPicker = styled(HexColorPicker)`
  width: 100%;
  border-radius: 8px;
`;

export const HexInput = styled(Field)`
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100px;
  font-family: monospace;
  font-size: 0.9rem;
  text-align: center;
  color: #1e293b;
  background-color: #f1f5f9;
`;

export const ColorPreviewBox = styled.div<{ bg: string }>`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background-color: ${(props) => props.bg};
  border: 1px solid #cbd5e1;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const EmptyMessage = styled.p`
  color: #64748b;
`;

export const ColorName = styled.span`
  font-weight: 500;
`;

export const ColorCode = styled.code`
  margin-left: auto;
  color: #475569;
`;

export const DeleteIcon = styled(FiX)`
  margin-left: 8px;
  cursor: pointer;
  color: #ef4444;
`;
